// config.js

// //Live
// export const API_URL = 'https://redskymetisindependentnation.ca';
//  export const API_URL = 'https://beta.redskymetisindependentnation.ca';

// // Development
// export const API_URL = 'http://localhost:5000';
// export const API_URL = 'http://localhost:5001';


// //Other
// export const API_URL = 'http://ec2-40-176-251-125.ca-west-1.compute.amazonaws.com:5000';
// export const API_URL = 'https://ec2-40-176-251-125.ca-west-1.compute.amazonaws.com:5000';
export const API_URL = process.env.REACT_APP_API_BASE || '';
export const CIP_APP_URL = process.env.REACT_APP_CIP_APP_URL || '';
export const CIP_RSMIN_TENANT_SLUG = process.env.REACT_APP_CIP_RSMIN_TENANT_SLUG || 'rsmin';
export const COMSAPP_APP_URL = process.env.REACT_APP_COMSAPP_APP_URL || '';
export const COMSAPP_DEV_SPACE_ID = process.env.REACT_APP_COMSAPP_DEV_SPACE_ID || '';